




















































import {Component, Prop, Vue } from 'vue-property-decorator';

import { Element } from "@api/models/Element"
import { CardColor } from '@share/common/cards/types/CardColor';
import { CardType } from '@share/common/cards/types/CardType';

import SegmentControl from '@share/common/segment/Segment.vue'
import AgendasFilter from "../filter/AgendasFilter.vue";
import CardsSection from "../cards-section/CardsSection.vue";

import { scrollDown } from "./helpers";
import { EventType } from '@share/common/types/enums/EventType';

@Component({
    components: { CardsSection, SegmentControl, AgendasFilter }
})
export default class NotNowSections extends Vue {

    @Prop({ default: []}) upcomingSessions: Element[];
    @Prop({ default: []}) pastSessions: Element[];

    @Prop({}) partners: Element[];

    CardColor = CardColor;
    CardType = CardType;

    cardClass = "ucc";
    activeSectionType: EventType = EventType.upcoming;

    thresholdCount = 8;

    changeType(value: EventType) {
        this.activeSectionType = value;
    }

    playUpcoming(data: Element) {
        if(data.isStarted) {
            this.$emit('play', data)
        }
        else {
            this.$emit('showSessionInfo', data)
        }
    }

    scrollDown() {

        const section = (this.$refs.section as Vue)?.$el as HTMLElement | undefined;

        if(section) {
            scrollDown(section, this.cardClass, this.$parent.$el as HTMLElement, 500, 350)
        }
    }

    get segmentData()  {
        return [{
            active: this.activeSectionType === EventType.upcoming,
            title: this.$t('common.upcoming'),
            value: EventType.upcoming
        },
        {
            active: this.activeSectionType === EventType.past,
            title: this.$t('common.past'),
            value: EventType.past
        }]
    }

    get agendasForFilter() {
        return this.showUpcoming ? this.upcomingSessions : this.pastSessions
    }

    private get isThereUpcoming() {
        return !!this.upcomingSessions.length || this.isOnEditing;
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    private get isTherePast() {
        return !!this.pastSessions.length;
    }

    private get showSegment() {
        //there are upcoming and past sessions
        return !!this.isThereUpcoming && this.isTherePast || (this.isTherePast && this.isOnEditing);
    }

    private get showUpcoming() {
        return this.showSegment ? this.activeSectionType === EventType.upcoming && this.isThereUpcoming : this.isThereUpcoming;
    }

    get showPast() {
        return this.showSegment ? this.activeSectionType === EventType.past && this.isTherePast : this.isTherePast;
    }
}

